import React from 'react';
import { Radio } from '@easyv/react-components';
import { ImmerFormItem } from '@/UIGenerator/uicomponents/ImmerFormItem';

interface ProjectionFormProps {
  geographicProjectionEnabled: boolean;
  value: 'xyz' | 'lonLat';
  onChange: (value: 'xyz' | 'lonLat') => void;
}

export function ProjectionForm(props: ProjectionFormProps) {
  const { geographicProjectionEnabled, value, onChange } = props;

  return geographicProjectionEnabled ? (
    <ImmerFormItem label='数据模式'>
      <Radio.Group
        type='button'
        size='small'
        value={value}
        onChange={(value) => {
          onChange(value);
        }}
        block
      >
        <Radio value='xyz'>空间坐标</Radio>
        <Radio value='lonLat'>经纬度坐标</Radio>
      </Radio.Group>
    </ImmerFormItem>
  ) : null;
}
